"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MODE_EDIT = exports.MODE_ADD = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _reactSortablejs = _interopRequireDefault(require("react-sortablejs"));

var _classnames = _interopRequireDefault(require("classnames"));

var _peractoUi = require("@peracto/peracto-ui");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faGripLines = require("@fortawesome/pro-regular-svg-icons/faGripLines");

var _faExclamationTriangle = require("@fortawesome/pro-regular-svg-icons/faExclamationTriangle");

var _reactToastify = require("react-toastify");

var _client = require("@peracto/client");

var _index = require("../../../../index");

var _excluded = ["mode"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MODE_ADD = 'add';
exports.MODE_ADD = MODE_ADD;
var MODE_EDIT = 'edit';
exports.MODE_EDIT = MODE_EDIT;
var INPUT_OPTION_TYPES = ['select', 'radio', 'multi-select'];

var getInputFieldType = function getInputFieldType(type) {
  switch (type) {
    case 'telephone':
      return 'tel';

    case 'date':
      return 'date';

    case 'email':
      return 'email';

    default:
      return 'text';
  }
};

var FormFieldsForm = function FormFieldsForm(_ref) {
  var _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? MODE_EDIT : _ref$mode,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDialog = _useState2[0],
      setShowDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      redirect = _useState4[0],
      setRedirect = _useState4[1];

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var onDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _e$error, _e$error$body;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return client(_client.DELETE, 'form-fields', {
                id: props.values.id
              });

            case 3:
              _reactToastify.toast.success('Form Field deleted successfully!');

              setRedirect('/form-fields');
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

              _reactToastify.toast.error(_context.t0 !== null && _context.t0 !== void 0 && (_e$error = _context.t0.error) !== null && _e$error !== void 0 && (_e$error$body = _e$error.body) !== null && _e$error$body !== void 0 && _e$error$body.hasOwnProperty('hydra:description') ? _context.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function onDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, redirect && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: redirect
  }), mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement(_peractoUi.FormActions, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "text-danger",
    onClick: function onClick() {
      return setShowDialog(true);
    },
    "data-testid": "delete-form-field"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    className: "mr-2"
  }), "Delete Form Field")), /*#__PURE__*/_react["default"].createElement(_peractoUi.Form, _extends({
    autoComplete: "off"
  }, props, {
    values: _objectSpread({
      label: '',
      helpText: '',
      inputType: null,
      inputOptions: [],
      defaultValue: '',
      thirdPartyFieldId: null,
      uniqueString: null
    }, props.values)
  }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Group, {
    key: "core",
    id: "core",
    name: "Core"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "label-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "label",
    label: "Label",
    placeholder: "Enter Label...",
    testId: "label",
    required: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "help-text-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
    name: "helpText",
    label: "Help Text",
    placeholder: "Enter Help Text...",
    testId: "help-text"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "input-section"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
    name: "inputType",
    label: "Input Type",
    placeholder: "Please select...",
    required: true,
    options: _index.inputTypeOptions,
    testId: "input-type"
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "inputOptions"
  }, function (_ref3) {
    var field = _ref3.field,
        form = _ref3.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, INPUT_OPTION_TYPES.includes(form.values.inputType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: field.name
    }, function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", null, "Input Options"), /*#__PURE__*/_react["default"].createElement("table", {
        className: "table table-sm mb-1"
      }, /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
        width: "5%"
      }), /*#__PURE__*/_react["default"].createElement("col", {
        width: "80%"
      }), /*#__PURE__*/_react["default"].createElement("col", {
        width: "15%"
      })), /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null), /*#__PURE__*/_react["default"].createElement("th", null, "Value"), /*#__PURE__*/_react["default"].createElement("th", {
        className: "text-right"
      }, "Remove"))), /*#__PURE__*/_react["default"].createElement(_reactSortablejs["default"], {
        tag: "tbody",
        onChange: function onChange(order, sortable, evt) {
          var values = _toConsumableArray(field.value);

          var movedItem = values[evt.oldIndex];
          var to = evt.newIndex;
          values.splice(evt.oldIndex, 1);
          values.splice(to, 0, movedItem);
          form.setFieldValue('inputOptions', values);
        },
        options: {
          animation: 100
        }
      }, field.value && field.value.length > 0 ? field.value.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.SortableRow, {
          key: index,
          "data-id": index
        }, /*#__PURE__*/_react["default"].createElement("td", {
          "data-testid": "row-".concat(index, "-slider")
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _faGripLines.faGripLines
        })), /*#__PURE__*/_react["default"].createElement("td", {
          "data-testid": "row-".concat(index, "-value")
        }, item), /*#__PURE__*/_react["default"].createElement("td", {
          className: "text-right"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-sm btn-danger",
          "data-testid": "row-".concat(index, "-remove"),
          onClick: function onClick() {
            var fieldVal = field.value || [];

            var values = _toConsumableArray(fieldVal);

            values.splice(index, 1);
            form.setFieldValue('inputOptions', _toConsumableArray(values)); // Clear defaultValue too if it's being removed from the form

            if (form.values.defaultValue === item) {
              form.setFieldValue('defaultValue', '');
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _faTrash.faTrash
        }))));
      }) : /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: "3",
        className: (0, _classnames["default"])('text-center', 'py-2', {
          'text-danger': form.errors[field.name]
        })
      }, form.errors[field.name] ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ' ', form.values.inputOptions.length == 0 ? 'This Input Type requires options to be created. Please update and try again.' : form.errors[field.name], ' ') : 'Add some Input Options')))));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "text",
      id: "inputOptions",
      className: "form-control",
      "data-testid": "input-option-field",
      placeholder: "Enter an input option",
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') {
          e.preventDefault();

          if (e.target.value.length > 0) {
            var fieldVal = field.value || [];

            var values = _toConsumableArray(fieldVal);

            values.push(e.target.value);
            form.setFieldValue('inputOptions', _toConsumableArray(values));
            e.target.value = '';
          }
        }
      }
    }))))));
  }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "defaultValue"
  }, function (_ref4) {
    var field = _ref4.field,
        form = _ref4.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !['checkbox', 'file', 'multi-select'].includes(form.values.inputType) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, INPUT_OPTION_TYPES.includes(form.values.inputType) ? /*#__PURE__*/_react["default"].createElement(_peractoUi.Select, {
      name: field.name,
      label: "Default Value",
      placeholder: "Please select...",
      testId: "default-value-dropdown",
      required: true,
      options: form.values.inputOptions && form.values.inputOptions.map(function (option) {
        return {
          label: option,
          value: option
        };
      }),
      allowClear: true
    }) : /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: field.name,
      type: getInputFieldType(form.values.inputType),
      label: "Default Value",
      placeholder: "Enter Default Value...",
      testId: "default-value"
    })));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "third-party-section"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "thirdPartyFieldId"
  }, function (_ref5) {
    var form = _ref5.form;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: "thirdPartyFieldId",
      label: "Third Party Field ID",
      placeholder: "Enter Third Party Field ID...",
      testId: "third-party-field-id",
      onChange: function onChange(e) {
        if (e.target.value === '') {
          form.setFieldValue('thirdPartyFieldId', null);
        } else {
          form.setFieldValue('thirdPartyFieldId', e.target.value);
        }
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "unique-string-section"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "uniqueString"
  }, function (_ref6) {
    var form = _ref6.form;
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.Input, {
      name: "uniqueString",
      label: "Unique String",
      placeholder: "Enter Unique String..",
      testId: "unique-string",
      onChange: function onChange(e) {
        if (e.target.value === '') {
          form.setFieldValue('uniqueString', null);
        } else {
          form.setFieldValue('uniqueString', e.target.value);
        }
      }
    });
  })))), mode === MODE_EDIT && /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
    isVisible: showDialog,
    title: "Delete Form Field",
    close: function close() {
      return setShowDialog(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Close',
      action: function action() {
        return setShowDialog(false);
      }
    }, {
      type: 'btn-danger',
      text: 'Delete Form Field',
      action: function action() {
        return onDelete();
      }
    }]
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "d-block mb-4"
  }), "Are you sure you would like to permanently delete this form field? Deleted form fields cannot be recovered."));
};

FormFieldsForm.displayName = 'FormFieldsForm';
FormFieldsForm.propTypes = {
  values: _propTypes["default"].object,
  mode: _propTypes["default"].oneOf([MODE_ADD, MODE_EDIT]),
  schema: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = FormFieldsForm;
exports["default"] = _default;